/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-10-19 11:53:57
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2020-10-19 11:54:39
 */
import Vue from 'vue'
export default new Vue()
